<template>
  <div>
    <v-row v-if="loading">
        <v-col cols="12" class="py-0">
          <v-progress-circular
            :size="size"
            color="primary"
            indeterminate></v-progress-circular>
        </v-col>
      </v-row>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    size: {
      type: Number,
      default: 50
    }
  }
}
</script>
